// extracted by mini-css-extract-plugin
export default {"btop":"_4324e2c295 _63cabe6c48 e0dc949a96","icon":"_945713a8fc c397bbe50f","btoppink":"a67899ac1d fe2606d387"};